export enum Constants {
  REINITIALIZE_LOCALE = '@@i18n/REINITIALIZE_LOCALE',
  UPDATE_LOCALE = '@@i18n/UPDATE_LOCALE',
}
